import { render, staticRenderFns } from "./OnboardingStory.vue?vue&type=template&id=7ab04664&"
import script from "./OnboardingStory.vue?vue&type=script&lang=js&"
export * from "./OnboardingStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports